var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTownhouseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_76_246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.6659 20.5347L35.5475 13.6019C35.557 13.5545 35.5665 13.5071 35.576 13.4502V4.38342C35.5665 3.84283 35.1397 3.40656 34.5991 3.3876H30.0657C29.5441 3.3876 29.1173 3.85231 29.1173 4.38342V8.1391L22.6208 2.60042C22.2699 2.29693 21.7482 2.29693 21.3878 2.60042L0.342744 20.5253C-0.0650697 20.8572 -0.11249 21.4547 0.219452 21.8625C0.551393 22.2703 1.14889 22.3178 1.5567 21.9858L1.57567 21.9668L22.0043 4.5731L29.3165 10.8041L33.6887 14.5219L42.4424 21.9763C42.8408 22.3178 43.4383 22.2703 43.7797 21.872C44.1116 21.4737 44.0642 20.8762 43.6659 20.5347ZM33.6697 11.9991L31.0142 9.76087V5.29389H33.6697V11.9991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.4836 22.4505L36.8185 20.1744L22.6209 8.04427C22.27 7.74078 21.7484 7.74078 21.388 8.04427L7.19037 20.1744L4.52535 22.4505C4.12702 22.792 4.0796 23.3895 4.42103 23.7878C4.75297 24.1861 5.34098 24.2335 5.72983 23.9016L5.73931 23.8921L6.92482 22.8678V40.6504C6.9343 41.1815 7.37057 41.6178 7.90168 41.6273H36.0977C36.6289 41.6178 37.0651 41.191 37.0746 40.6504V22.8678L38.2601 23.8921C38.4308 24.0344 38.6395 24.1197 38.8671 24.1197C39.1421 24.1197 39.4077 23.9964 39.5879 23.7878C39.9388 23.38 39.8819 22.7825 39.4836 22.4505ZM25.7981 39.721H18.2108V29.4782H25.7981V39.721ZM27.6949 39.721V28.5583C27.6949 28.0366 27.306 27.5814 26.7844 27.5814H17.2245C16.7029 27.5814 16.314 28.0366 16.314 28.5583V39.721H8.82163V21.2461L22.0045 10.0169L35.1873 21.2461V39.721H27.6949Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTownhouseBlack);
export default __webpack_public_path__ + "static/media/townhouse-black.a5190aae0a1da4b07f1a33cc85a626c5.svg";
export { ForwardRef as ReactComponent };